import { useMemo } from 'react';
import { useEssentials } from '../../../contexts/essentials-context';

type DateFormatter = (date: Date) => string;

export const useDateFormatter = (): DateFormatter => {
  const { languageCode } = useEssentials();
  const { format } = useMemo(
    () =>
      new Intl.DateTimeFormat(languageCode || 'en', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: 'UTC',
        timeZoneName: 'short',
        hour12: false,
      }),
    [languageCode],
  );

  return (date: Date) => format(date);
};
